import React, { Fragment } from "react"

import { states } from "../../../../../../legacyComponents/util/constants"
import { styles } from "."

import { Stack, Typography } from "@mui/material"
import { TextField } from "../../../../../../legacyComponents/componentsV2/FlowV2/Fields"

export default function RatingAreas(props) {
	const { formik, displayOnly } = props
	const { values, setFieldValue } = formik
	const { ratingAreas } = values

	function handleChange(event) {
		const key = event?.target?.id
		const checked = event?.target?.checked
		const value = { ...ratingAreas, [key]: checked }
		setFieldValue("ratingAreas", value)
		if(key == "other" && !checked)
		{
			setFieldValue("otherRatingArea","");
		}
	}

	return (
		<Fragment>
			<Typography>Select states to include in this class.</Typography>

			<Stack direction="row" sx={{ flexWrap: "wrap" }}>
				{[...Object.keys(states), "other"]?.map((key) => {
					const checked = ratingAreas?.[key]

					return (
						<Stack key={key} spacing="10px" direction="row" sx={styles.checkboxContainer}>
							<input
								id={key}
								type="checkbox"
								checked={checked}
								disabled={displayOnly}
								style={styles.checkbox}
								onChange={handleChange}
							/>

							<Typography component="label" htmlFor={key} sx={styles.checkboxLabel}>
								{key === "other" ? "Other" : key}
							</Typography>
						</Stack>
					)
				})}
			</Stack>

			<TextField
				formik={formik}
				type="text"
				name="otherRatingArea"
				label="Enter other rating area"
				disabled={displayOnly}
				hidden={({ values }) => !values?.ratingAreas?.other}
				validation="string"
			/>
		</Fragment>
	)
}
